import type { DeepPartial } from '@luna/utils-ts';
import type { ExportFeatureConfig, TransactionsFeatureConfig } from '@shared/transactions-config';
import { isFeatureEnabled } from '@luna/gatekeeper';

const shouldShowFavoriteField = (): boolean => isFeatureEnabled((f) => f.transactions.favorites);

export const transactions: DeepPartial<TransactionsFeatureConfig> = {
    showReceiverAddress: true,
    showReceiverName: true,
    claims: {
        handover: {
            paramNames: ['client_id', 'lang', 'transaction_id'],
        },
    },
};

export const exportFeatures: DeepPartial<ExportFeatureConfig> = {
    fields: [
        { name: 'ownerAccountTitle', preselected: true, selectable: true },
        { name: 'ownerAccountNumber', preselected: true, selectable: true },
        { name: 'booking', preselected: true, selectable: true },
        { name: 'amount', preselected: true, selectable: true },
        { name: 'currency', preselected: true, selectable: true },
        { name: 'receiver', preselected: true, selectable: true },
        { name: 'reference', preselected: true, selectable: true },
        { name: 'referenceNumber', preselected: false, selectable: true },
        { name: 'note', preselected: false, selectable: true },
        {
            name: 'favorite',
            condition: shouldShowFavoriteField,
            preselected: false,
            selectable: true,
        },
        { name: 'category', preselected: false, selectable: true },
        { name: 'cardNumber', preselected: false, selectable: true },
        { name: 'cardLocation', preselected: false, selectable: true },
        { name: 'bookingTypeTranslation', preselected: false, selectable: true },
        { name: 'senderModeReference', preselected: false, selectable: true },
        { name: 'receiverModeReference', preselected: false, selectable: true },
        { name: 'sepaPurposeType', preselected: false, selectable: true },
        { name: 'senderOriginator', preselected: false, selectable: true },
        { name: 'receiverName', preselected: false, selectable: true },
        { name: 'receiverAddress', preselected: false, selectable: true },
    ],
};
